import React, { useEffect, useRef, useState } from "react";
import "./App.css";
import CircleOverlay from "./components/CircleOverlay";
import Home from "./components/Home";
import Loader from "./components/Loader";
import { useProjectNavigation } from "./hooks/useProjectNavigation";
import { useLoaderAnimation } from "./hooks/useLoaderAnimation";
import { useWindowSize } from "./hooks/useWindowSize";

function App() {
  const scrollRef = useRef(null);
  const width = useWindowSize();
  const [index, setindex] = useState(0);
  const { turnOnProject, turnOffProject } = useProjectNavigation();
  const progress = useLoaderAnimation();
  useEffect(() => {
    setindex(width > 768 ? 4 : 0);
  }, [width]);

  const handleTurnOnProject = () => turnOnProject(scrollRef);
  const handleTurnOffProject = () => turnOffProject(scrollRef);
  return (
    <div className="bg-[#0F0E0E] w-[100%] mainContainer opacity-0 ">
      <div ref={scrollRef} className="scrolltotop"></div>
      <div className="w-screen h-screen fixed top-0 left-0 pointer-events-none">
        <span className="circle1 absolute top-[15%] left-[34%]">
          <CircleOverlay index={index} />
        </span>
        <span className="circle2 absolute top-[50%] left-[134%]">
          <CircleOverlay index={index} />
        </span>
      </div>
      <Loader progress={progress} width={width} />
      <Home
        setindex={setindex}
        index={index}
        width={width}
        turnOffProject={handleTurnOffProject}
        turnOnProject={handleTurnOnProject}
      />
    </div>
  );
}

export default App;
